import { consoleLogger } from '@shared/logging/consoleLogger';
import { loadUtiqConsentManager } from '@utiqLoader/consentManager/loadUtiqConsentManager';
import { setErrorMessageForAPIMethod } from '@shared/api/utiqAPIMethods';

export const handleUtiqConsentManager = ({
  isOtherConsentManagementPlatformSet,
}: {
  isOtherConsentManagementPlatformSet: boolean;
}) => {
  if (isOtherConsentManagementPlatformSet) {
    setErrorMessageForAPIMethod(
      'showConsentManager',
      'Method "showConsentManager" is currently unavailable, because utiqConsentManager.js is not loaded, as we don\'t show ' +
        'Utiq pop-up on Manage Utiq pages or if any other Consent Management Platform is Set',
    );
    return;
  }

  if (document.getElementById('utiq__consent-manager')) {
    consoleLogger.logDebug(
      'Utiq consent manager is already loaded on the page. Proceeding...',
    );
    return;
  }
  loadUtiqConsentManager();
};
